export default __webpack_public_path__ + "static/media/7.fefb1843.webp";